<template>
  <div>
    <BaseHeader>
      <template v-slot:title>Settings</template>
    </BaseHeader>

    <b-container>
      <b-row>
        <b-col md="6">
          <FormChangePassword />
        </b-col>
        <b-col md="6" class="mt-5 mt-md-0">
          <!--
            Exactly one 2FA panel renders. An SSO user's factors live in Entra, so
            the legacy authenticator-app panel would offer them a control that
            changes nothing about how they actually sign in. Form2FASettingsSso
            asks the server whether it applies and reports back through
            @availability; until it answers, neither panel shows, which is briefer
            than the wrong one.
          -->
          <Form2FASettingsSso @availability="onSsoAvailability" />
          <Form2FASettings v-if="ssoAvailable === false" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'

import { BaseHeader } from '@/components/base'
import FormChangePassword from '@components/FormChangePassword.vue'
import Form2FASettings from '@components/Form2FASettings.vue'
import Form2FASettingsSso from '@components/Form2FASettingsSso.vue'

export default defineComponent({
  name: 'UserSettings',
  title: 'Settings',
  components: {
    BaseHeader,
    FormChangePassword,
    Form2FASettings,
    Form2FASettingsSso
  },
  setup() {
    // null = not yet known. Deliberately three-valued rather than defaulting to
    // false: defaulting would flash the legacy panel at every SSO user on load.
    const ssoAvailable = ref(null)

    const onSsoAvailability = (isAvailable) => {
      ssoAvailable.value = !!isAvailable
    }

    return { ssoAvailable, onSsoAvailability }
  }
})
</script>
